export default "__VITE_ASSET__CfBkjQNk__"